const selectSaldo = (state => state.saldoUsuario);


export default selectSaldo;